import { Limit } from './../../limits/models/limits';
import { Component, OnInit, ViewEncapsulation, Input, OnChanges, EventEmitter, Output, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { TransfersOtherBanksEventType } from '../transfers-other-banks.event.type';
import { TweenMax, Quint } from 'gsap';
import { Transfer } from '../../models/transfer';
import * as moment from 'moment';
import { EventTypes } from '../../../shared/EventTypes';
import { TransfersOtherBanksService } from '../transfers-other-banks.service';
import { LimitsService } from '../../limits/limits.service';
import { ModalErrorEventType } from '../../../shared/modal-error/modal-error.event.type';
import { ModalConfirmService } from '../../../shared/modal-confirm/modal-confirm.service';
import { SharedService } from '../../../shared/shared.service';

@Component({
	selector: 'app-transfer-data',
	templateUrl: './transfer-data.component.html',
	styleUrls: ['./transfer-data.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class TransferDataComponent implements OnInit, OnDestroy {

	@Input() submited = false;
	@Input() transferData: Transfer;
	@Input() showBalance;
	@Output() showBalanceChange: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() setForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

	private today: number = Date.now();
	private view = '[data-component="transfer-data"]';
	private minDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
	private lastChackedDate?: Date;
	private hasCheckedToday = false;

	form: FormGroup;
	scheduleSpan = false;
	scheduleError = false;
	dataLimits: Array<Limit>;
	active = false;
	data: any;

	constructor(
		private formBuilder: FormBuilder,
		private transferOBService: TransfersOtherBanksService,
		private limitsService: LimitsService,
		private sharedService: SharedService,
		private modalConfirmService: ModalConfirmService,
	) {
		this.scheduleSpan = this.transferOBService.scheduleSpan;

		this.form = formBuilder.group({
			'value': [null, Validators.required],
			'transferDate': ['today', Validators.required],
			'scheduleDate': [null]
		});

	}

	dateFormat(e) {
		let newDate = e.target.value.toString();
		newDate = newDate.replace(/\D/g, '');
		newDate = newDate.replace(/(\d{2})(\d)/, '$1/$2');
		newDate = newDate.replace(/(\d{2})(\d)/, '$1/$2');
		this.scheduleError = true;

		if (newDate.length === 10) {
			this.scheduleError = false;
			const data = moment(newDate, 'DD/MM/YYYY');

			if (data.isValid() && data.isAfter(moment())) {
				e.target.value = newDate;
				this.form.get('scheduleDate').setValue(data.toDate());
				this.form.get('scheduleDate').setErrors(null);
				this.checkDateOption('schedule');
				return;
			}

			e.target.value = newDate;
			this.form.get('scheduleDate').setErrors({ 'required': true });
			this.scheduleError = true;

		} else {
			e.target.value = newDate;
		}
	}

	verifyZero() {
		if ($('.currency-field').val() === '0,00') {
			$('.currency-field').val('');
		}
	}

	ngOnInit() {
		this.loadLimits();

		AppEventDispatcher.listen(TransfersOtherBanksEventType.STEPS.TRANSFER_DATA, data => {
			if (data.show) {
				this.active = true;
				this.setForm.emit(this.form);
				this.show();
			} else {
				this.hide();
			}
		});

		AppEventDispatcher.listen(ModalErrorEventType.MODAL.CANCEL, data => {
			AppEventDispatcher.dispatch(EventTypes.MODAL_ERROR.MODAL_CLOSE, {});
		});

		AppEventDispatcher.listen(ModalErrorEventType.MODAL.OK, data => {
			AppEventDispatcher.dispatch(EventTypes.MODAL_ERROR.MODAL_CLOSE, {});
		});

		AppEventDispatcher.listen(TransfersOtherBanksEventType.TRANSFER.SEND, () => {
			this.hide();
		});

	}

	loadLimits() {
		this.preload(true);

		let time = 1;
		const timeLoader = setInterval(() => {
			time++;
		}, 1000);

		this.transferOBService.getDataLimits().subscribe(data => {

			data = data.filter((e) => {
				return e;
			});

			this.dataLimits = data;

			this.preload(false);

		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(TransfersOtherBanksEventType.STEPS.TRANSFER_DATA);
		AppEventDispatcher.removeListener(TransfersOtherBanksEventType.TRANSFER.SEND);
		AppEventDispatcher.removeListener(ModalErrorEventType.MODAL.CANCEL);
		AppEventDispatcher.removeListener(ModalErrorEventType.MODAL.OK);
	}

	setTransferData() {
		this.transferData.value = this.form.controls.value.value;

		if (this.form.controls.transferDate.value === 'today') {
			this.transferData.date = new Date();
			this.transferData.dateLabel = moment(new Date()).format('DD/MM/YYYY');
			this.transferData.dateType = 'today';
		} else {
			this.transferData.date = this.form.controls.scheduleDate.value;
			this.transferData.dateLabel = moment(this.form.controls.scheduleDate.value).format('DD/MM/YYYY');
			this.transferData.dateType = 'schedule';
		}

	}

	checkDateOption(type = 'today') {
		if (type === 'schedule') {
			this.scheduleSpan = true;
			this.transferOBService.scheduleSpan = true;

			AppEventDispatcher.dispatch(TransfersOtherBanksEventType.MODAL.TRUE_MODAL, { data: false });

			let hasThisDateChecked = false;
			
			if(this.lastChackedDate && this.form.controls.scheduleDate.value){
				hasThisDateChecked = this.lastChackedDate.getTime() === this.form.controls.scheduleDate.value.getTime();
			}

			if (moment().isBefore(this.form.controls.scheduleDate.value) && !hasThisDateChecked) {
				this.sharedService.getDateBlockValidation(this.transferData.transferType, this.form.controls.scheduleDate.value).subscribe(
					(data) => {
						if (data.Retorno.Aviso) {
							this.modalConfirmService.openAlertModal(data.Retorno.Titulo, '', data.Retorno.Mensagem, 'Entendi', true);
						};
						this.lastChackedDate = this.form.controls.scheduleDate.value;
						return;
					},
				);
			}

			this.form.controls.scheduleDate.setValidators(Validators.required);
			this.form.controls.scheduleDate.updateValueAndValidity();

			if (moment().isAfter(this.form.controls.scheduleDate.value)) {
				this.scheduleError = true;
			} else {
				this.scheduleError = false;
			}

			this.form.controls.transferDate.setValue('schedule');

		} else {
			this.scheduleSpan = false;
			this.transferOBService.scheduleSpan = false;
			
			AppEventDispatcher.dispatch(TransfersOtherBanksEventType.MODAL.TRUE_MODAL, { data: true });
			this.form.controls.scheduleDate.clearValidators();
			this.form.controls.scheduleDate.setValue('');

			if(!this.hasCheckedToday){
				this.sharedService.getDateBlockValidation(this.transferData.transferType, null).subscribe(
					(data) => {
						if (data.Retorno.Aviso) {
							this.modalConfirmService.openAlertModal(data.Retorno.Titulo, '', data.Retorno.Mensagem, 'Entendi', true);
						};
						this.hasCheckedToday = true;
						return;
					},
				);
			}
		}
	}

	show() {
		this.checkDateOption();
		TweenMax.delayedCall(.5, () => {
			const containerHeight = $(this.view).outerHeight() + $('.buttons').outerHeight() + 50;

			TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut });
			TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut });

			AppEventDispatcher.dispatch(TransfersOtherBanksEventType.MODAL.TRUE_MODAL, { data: true });

			$('.currency-field').val('');

		});

		this.showBalanceChange.emit(true);

	}

	consultService(time, timeLoader) {

		this.transferOBService.sendTransfer(this.transferData).subscribe(res => {

			this.transferData.id = res.Retorno.TransferenciaID;

			if (res.Retorno.DadosEntrada.DataAgendamento) {
				this.transferOBService.scheduleSpan = true;
				this.transferData.dateLabel = moment(res.Retorno.DadosEntrada.DataAgendamento).format('DD/MM/YYYY');
			} else {
				this.transferOBService.scheduleSpan = false;
				this.transferData.dateLabel = moment(res.Retorno.DadosEntrada.DataEmissao).format('DD/MM/YYYY');
			}

			if (time > 3) {
				this.preload(false);
				this.hideAfterSend();
			} else {
				TweenMax.delayedCall(3 - time, () => {
					this.preload(false, 3 - time);
					this.hideAfterSend();
				});
			}
			clearInterval(timeLoader);

		}, res => {


			if (time > 3) {
				AppEventDispatcher.dispatch(TransfersOtherBanksEventType.ERROR, { step: TransfersOtherBanksEventType.STEPS.FAVORED_DATA });
				this.preload(false);
				this.backAfterError();
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK,
					{ msg: res.error.Retorno.stage[0].Value['_errors'][0]['<ErrorMessage>k__BackingField'] });
			} else {
				AppEventDispatcher.dispatch(TransfersOtherBanksEventType.ERROR, { step: TransfersOtherBanksEventType.STEPS.FAVORED_DATA });
				TweenMax.delayedCall(3 - time, () => {
					this.preload(false, 3 - time);
					this.backAfterError();
					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK,
						{ msg: res.error.Retorno.stage[0].Value['_errors'][0]['<ErrorMessage>k__BackingField'] });
				});
			}
			clearInterval(timeLoader);

		});
	}

	hide() {

		this.setTransferData();

		this.preload(true);

		let time = 1;
		const timeLoader = setInterval(() => {
			time++;
		}, 1000);

		this.consultService(time, timeLoader);

	}


	hideAfterSend() {
		TweenMax.delayedCall(1, () => {

			TweenMax.to(this.view, .2, {
				delay: .2, left: '-100%', ease: Quint.easeOut, onComplete: () => {
					this.active = false;
				}
			});

			AppEventDispatcher.dispatch(TransfersOtherBanksEventType.STEPS.TRANSFER_CONFIRMATION, { show: true });
		});

	}

	backAfterError() {
		TweenMax.delayedCall(1, () => {

			AppEventDispatcher.dispatch(TransfersOtherBanksEventType.STEPS.FAVORED_DATA, { show: true });

			TweenMax.to(this.view, .8, {
				delay: .4, left: '100%', ease: Quint.easeOut, onComplete: () => {
					this.active = false;
				}
			});

		});
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{ element: '[data-component="transfers-other-banks"] .content', show: active, delay: delay });
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/transfers-other-banks/transfer-data/transfer-data.component.ts